export default {
    position: {
        backToDashboard: 'Back to dashboard',
        loadError: "Couldn't load position for contract",
        tryAgain: 'Try again',
        header: 'Position view — {name} · {country} · {side} · {product}',
        deliveryLine: 'Delivery: {start} → {end} · {mwh} contributed by this contract',
        mergeMeta: 'Last merge run: {lastRun} · {days} days · {buckets} buckets',
        noSnapshotTitle: 'No position snapshot yet',
        noSnapshotBody:
            "Merge for {start}–{end} hasn't been triggered. Once merged, this contract's contribution will appear here.",
        prevDayAria: 'Previous day (Alt+←)',
        nextDayAria: 'Next day (Alt+→)',
        show: 'Show:',
        forecastBaseline: 'Forecast baseline',
        thisContract: 'This contract',
        allFutures: 'All futures',
        zeroContribution:
            'This contract has no delivery on {day} (outside delivery window or zero allocation).',
        footerSummary:
            'This day · forecast {forecast} MWh · futures {futures} MWh · final {final} MWh · direction {direction}',
    },
}
